export const validateEmail = (email) => {
    let regex = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/g
    return regex.test(email)
}

export const validateOTP = (otp) => {
    let regex = /^\d{6}$/g
    return regex.test(otp)
}
